import { APICallV3Post, APICallV4Post } from 'reactApp/api/APICall';

export class R7CommentApiAPICallV3 extends APICallV3Post {
    _method = 'r7/comment';
}

export class R7CommentApiAPICallV4 extends APICallV4Post {
    _method = 'r7/comment';
}
